import * as React from 'react';
import * as styles from './styles.css';

import { Preloader as PreloaderLib } from '@cian/preloader-component';

export function Preloader() {
  return (
    <div className={styles['container']}>
      <PreloaderLib size={32} />
    </div>
  );
}
